import type * as core from '../../../../../../../core'

// At the root level (no policyAreaId) the table lists Policy Areas; clicking an
// area drills into it, listing that area's Policies. The assistant can be
// opened over one policy, every policy in an area, or all policies. Each
// Policy's documents are stored in the shared knowledge base scoped to that
// record, so the records passed to the assistant authorize it to retrieve
// exactly those documents.
export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: {
        if: [
          [
            {
              '=': [
                {
                  '@$': 'policyAreaId',
                },
                null,
              ],
            },
            'Policy Areas',
          ],
          'Policies',
        ],
      },
      type: 'table',
      overflowActions: {
        if: [
          [
            {
              '=': [
                {
                  '@$': 'policyAreaId',
                },
                null,
              ],
            },
            {
              '[]': [
                {
                  '{}': {
                    icon: 'atn-icon atn-comment atn-blue',
                    name: 'Ask about all policies',
                    action: {
                      '{}': {
                        payload: {
                          '{}': {
                            agentId: 'policyAssistant',
                            records: {
                              '??': [
                                {
                                  '@': 'allPolicyRecords',
                                },
                                {
                                  '[]': [],
                                },
                              ],
                            },
                          },
                        },
                        operation: 'ui.open-assistant',
                      },
                    },
                  },
                },
              ],
            },
          ],
          {
            '[]': [
              {
                '{}': {
                  icon: 'atn-icon atn-comment atn-blue',
                  name: 'Ask about this area',
                  action: {
                    '{}': {
                      payload: {
                        '{}': {
                          agentId: 'policyAssistant',
                          records: {
                            '??': [
                              {
                                '@': 'areaPolicyRecords',
                              },
                              {
                                '[]': [],
                              },
                            ],
                          },
                        },
                      },
                      operation: 'ui.open-assistant',
                    },
                  },
                },
              },
              {
                '{}': {
                  icon: 'atn-icon atn-comment atn-blue',
                  name: 'Ask about all policies',
                  action: {
                    '{}': {
                      payload: {
                        '{}': {
                          agentId: 'policyAssistant',
                          records: {
                            '??': [
                              {
                                '@': 'allPolicyRecords',
                              },
                              {
                                '[]': [],
                              },
                            ],
                          },
                        },
                      },
                      operation: 'ui.open-assistant',
                    },
                  },
                },
              },
            ],
          },
        ],
      },
      content: {
        '{}': {
          query: {
            if: [
              [
                {
                  '=': [
                    {
                      '@$': 'policyAreaId',
                    },
                    null,
                  ],
                },
                {
                  '`': {
                    target: 'ent:!policies:!policy_area',
                    sort: {
                      by: {
                        '@.': '!sort_order',
                      },
                    },
                    selection: {
                      '{}': {
                        fields: {
                          '{}': {
                            name: {
                              '{}': {
                                value: {
                                  '@.': '!name',
                                },
                              },
                            },
                            descr: {
                              '{}': {
                                value: {
                                  '@.': '!descr',
                                },
                              },
                            },
                            policyCount: {
                              '{}': {
                                value: {
                                  '#': {
                                    '@': 'policyRecords',
                                  },
                                },
                              },
                            },
                          },
                        },
                        onClick: {
                          '{}': {
                            action: {
                              '{}': {
                                payload: {
                                  '{}': {
                                    goto: {
                                      '{}': {
                                        variables: {
                                          '{}': {
                                            policyAreaId: {
                                              '@.': '!id',
                                            },
                                          },
                                        },
                                        navigationId: 'policy-explorer',
                                      },
                                    },
                                  },
                                },
                                operation: 'ui.navigate',
                              },
                            },
                          },
                        },
                        overflowActions: {
                          '[]': [
                            {
                              '{}': {
                                icon: 'atn-icon atn-comment atn-blue',
                                name: 'Ask about this area',
                                action: {
                                  '{}': {
                                    payload: {
                                      '{}': {
                                        agentId: 'policyAssistant',
                                        records: {
                                          '??': [
                                            {
                                              '@': 'policyRecords',
                                            },
                                            {
                                              '[]': [],
                                            },
                                          ],
                                        },
                                      },
                                    },
                                    operation: 'ui.open-assistant',
                                  },
                                },
                              },
                            },
                          ],
                        },
                      },
                    },
                    subqueries: {
                      policyRecords: {
                        target: 'child',
                        selection: {
                          '{}': {
                            modelId: 'ent:!policies:!policy',
                            recordId: {
                              '@.': '!id',
                            },
                          },
                        },
                      },
                    },
                  },
                },
              ],
              {
                '`': {
                  filter: {
                    '=': [
                      {
                        '@^': 'parent',
                      },
                      {
                        '``': {
                          '@$': 'policyAreaId',
                        },
                      },
                    ],
                  },
                  target: 'ent:!policies:!policy',
                  sort: {
                    by: {
                      '@.': '!name',
                    },
                  },
                  selection: {
                    '{}': {
                      fields: {
                        '{}': {
                          name: {
                            '{}': {
                              value: {
                                '@.': '!name',
                              },
                            },
                          },
                          descr: {
                            '{}': {
                              value: {
                                '@.': '!descr',
                              },
                            },
                          },
                          owner: {
                            '{}': {
                              value: {
                                '@.': '!owner',
                              },
                            },
                          },
                          version: {
                            '{}': {
                              value: {
                                '@.': '!version',
                              },
                            },
                          },
                          effectiveDate: {
                            '{}': {
                              value: {
                                '@.': '!effective_date',
                              },
                            },
                          },
                        },
                      },
                      onClick: {
                        '{}': {
                          action: {
                            '{}': {
                              payload: {
                                '{}': {
                                  agentId: 'policyAssistant',
                                  records: {
                                    '[]': [
                                      {
                                        '{}': {
                                          modelId: 'ent:!policies:!policy',
                                          recordId: {
                                            '@.': '!id',
                                          },
                                        },
                                      },
                                    ],
                                  },
                                },
                              },
                              operation: 'ui.open-assistant',
                            },
                          },
                        },
                      },
                      overflowActions: {
                        '[]': [
                          {
                            '{}': {
                              icon: 'atn-icon atn-comment atn-blue',
                              name: 'Ask about this policy',
                              action: {
                                '{}': {
                                  payload: {
                                    '{}': {
                                      agentId: 'policyAssistant',
                                      records: {
                                        '[]': [
                                          {
                                            '{}': {
                                              modelId: 'ent:!policies:!policy',
                                              recordId: {
                                                '@.': '!id',
                                              },
                                            },
                                          },
                                        ],
                                      },
                                    },
                                  },
                                  operation: 'ui.open-assistant',
                                },
                              },
                            },
                          },
                        ],
                      },
                    },
                  },
                },
              },
            ],
          },
          columns: {
            if: [
              [
                {
                  '=': [
                    {
                      '@$': 'policyAreaId',
                    },
                    null,
                  ],
                },
                {
                  '[]': [
                    {
                      '{}': {
                        id: 'name',
                        direct: {
                          '{}': {
                            name: 'Name',
                            type: 'TEXT',
                          },
                        },
                        isSortable: true,
                      },
                    },
                    {
                      '{}': {
                        id: 'descr',
                        direct: {
                          '{}': {
                            name: 'Description',
                            type: 'TEXT',
                          },
                        },
                        isSortable: true,
                      },
                    },
                    {
                      '{}': {
                        id: 'policyCount',
                        direct: {
                          '{}': {
                            name: 'Policies',
                            type: 'INT',
                          },
                        },
                        isSortable: true,
                      },
                    },
                  ],
                },
              ],
              {
                '[]': [
                  {
                    '{}': {
                      id: 'name',
                      direct: {
                        '{}': {
                          name: 'Name',
                          type: 'TEXT',
                        },
                      },
                      isSortable: true,
                    },
                  },
                  {
                    '{}': {
                      id: 'descr',
                      direct: {
                        '{}': {
                          name: 'Summary',
                          type: 'TEXT',
                        },
                      },
                      isSortable: true,
                    },
                  },
                  {
                    '{}': {
                      id: 'owner',
                      direct: {
                        '{}': {
                          name: 'Owner',
                          type: 'TEXT',
                        },
                      },
                      isSortable: true,
                    },
                  },
                  {
                    '{}': {
                      id: 'version',
                      direct: {
                        '{}': {
                          name: 'Version',
                          type: 'TEXT',
                        },
                      },
                      isSortable: true,
                    },
                  },
                  {
                    '{}': {
                      id: 'effectiveDate',
                      direct: {
                        '{}': {
                          name: 'Effective Date',
                          type: 'DATE',
                        },
                      },
                      isSortable: true,
                    },
                  },
                ],
              },
            ],
          },
        },
      },
    },
  },
  variables: {
    policyAreaId: null,
  },
  // These subqueries are outside the backtick-quoted table queries above, so
  // they reference the policyAreaId variable directly
  subqueries: {
    allPolicyRecords: {
      target: 'ent:!policies:!policy',
      selection: {
        '{}': {
          modelId: 'ent:!policies:!policy',
          recordId: {
            '@.': '!id',
          },
        },
      },
    },
    areaPolicyRecords: {
      filter: {
        '=': [
          {
            '@^': 'parent',
          },
          {
            '@$': 'policyAreaId',
          },
        ],
      },
      target: 'ent:!policies:!policy',
      selection: {
        '{}': {
          modelId: 'ent:!policies:!policy',
          recordId: {
            '@.': '!id',
          },
        },
      },
    },
  },
}
